@if (includeDivider) {
<forge-divider></forge-divider>
}
@if (showHeader) {
<div class="forge-typography--heading2 metadata-header" focusOnLoad>
    {{ label }}
</div>
}